import { Form } from '@calendly/form';
import { useEditorContent } from '@calendly/rich-text-editor';
import { Modal } from '@calendly/ui/components/modal';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { Footer } from './components/footer';
import { Header } from './components/header';
import { SendFromCalendlyEmailForm } from './components/send-from-calendly-email-form';
import { validationSchema } from './config';
const bodyIsPhoneCss = "b19hqy82";
const bodyCss = "bhj80x3";
const Body = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(bodyCss, {
    [bodyIsPhoneCss]: isPhone
  }, props.className)} />;
});
export const SendFromCalendlyEmailModal = ({
  isOpen,
  onClose,
  onConfirm,
  onBack,
  title,
  subTitle,
  emails,
  isLoading,
  initialSubject,
  initialBody,
  initialIncludeCancellation = false,
  showCancellationPolicyCheckbox,
  eventType,
  userData,
  contact,
  source = null
}) => {
  const [isEditorReady, {
    fromText: textToEditorContent,
    fromHTML: htmlToEditorContent
  }] = useEditorContent();
  if (!isEditorReady) {
    return null;
  }
  const formInitialValues = {
    send_with: emails.length ? `${emails[0].type}_${emails[0].accountUuid}` : '',
    subject: textToEditorContent(initialSubject),
    body: htmlToEditorContent(initialBody),
    include_cancellation_policy: initialIncludeCancellation
  };
  const anyConnectedEmails = emails.filter(email => email.accessGranted).length > 0;
  return <Modal isOpen={isOpen}>
      <Body>
        <Form initialValues={formInitialValues} validationSchema={validationSchema()} onSubmit={onConfirm}>
          <Header onClose={onClose} title={title} subTitle={subTitle} />
          <SendFromCalendlyEmailForm emails={emails} isLoading={isLoading} eventType={eventType} userData={userData} contact={contact} source={source} />
          <Footer onBack={onBack} isLoading={isLoading} showCancellationPolicyCheckbox={showCancellationPolicyCheckbox} activeSendButton={anyConnectedEmails} />
        </Form>
      </Body>
    </Modal>;
};

require("./send-from-calendly-email-modal.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./send-from-calendly-email-modal.js");